export const CEP_DIGIT_LENGTH = 8

export function stripCep(raw: string | null | undefined): string {
  return (raw ?? '').replace(/\D/g, '')
}

export function maskCep(raw: string | null | undefined): string {
  const digits = stripCep(raw).slice(0, CEP_DIGIT_LENGTH)
  if (digits.length <= 5) {
    return digits
  }
  return `${digits.slice(0, 5)}-${digits.slice(5)}`
}